<template >
  <div :key="'composition-api-example-no-component'">
    <pre><code class="javascript" data-trim data-noescape data-line-numbers="1-99" v-html="exampleText"></code></pre>
  </div>
</template>

<script>
export default {
  data() {
    return {
      exampleText: `import { reactive, watch } from 'vue'

const state = reactive({
  count: 0
})

watch(() => {
  document.body.innerHTML = \`count is \${state.count}\`
})`
    };
  }
};
</script>
